// extracted by mini-css-extract-plugin
export default {"wrapper":"SamlCallback_wrapper__uycI0","container":"SamlCallback_container__uYl1I","heading":"SamlCallback_heading__sJm5Y","subHeading":"SamlCallback_subHeading__Rn3Bn"};